export default "<ion-app>\n  <ion-router-outlet main id=\"main-content\"></ion-router-outlet>\n</ion-app>";